export type IntegrationCategory = 'accounting' | 'banking' | 'revenue' | 'payroll' | 'workspace'

export type Integration = {
    name: string
    short: string
    category: IntegrationCategory
    sync: string
}

export const INTEGRATION_CATEGORIES: Array<{ id: IntegrationCategory | 'all', label: string }> = [
    { id: 'all', label: 'All' },
    { id: 'accounting', label: 'Accounting' },
    { id: 'banking', label: 'Banking and cards' },
    { id: 'revenue', label: 'Revenue' },
    { id: 'payroll', label: 'Payroll and HR' },
    { id: 'workspace', label: 'Workspace' }
]

export const CATEGORY_LABELS: Record<IntegrationCategory, string> = {
    accounting: 'Accounting',
    banking: 'Banking and cards',
    revenue: 'Revenue',
    payroll: 'Payroll and HR',
    workspace: 'Workspace'
}

export const INTEGRATIONS: Array<Integration> = [
    { name: 'QuickBooks Online', short: 'QB', category: 'accounting', sync: 'Two-way sync' },
    { name: 'Xero', short: 'Xe', category: 'accounting', sync: 'Two-way sync' },
    { name: 'NetSuite', short: 'NS', category: 'accounting', sync: 'Two-way sync' },
    { name: 'Sage Intacct', short: 'SI', category: 'accounting', sync: 'Two-way sync' },
    { name: 'Plaid', short: 'Pl', category: 'banking', sync: 'Read-only bank feeds' },
    { name: 'Mercury', short: 'Me', category: 'banking', sync: 'Read-only bank feeds' },
    { name: 'American Express', short: 'Ax', category: 'banking', sync: 'Read-only card feeds' },
    { name: 'Brex', short: 'Bx', category: 'banking', sync: 'Read-only card feeds' },
    { name: 'Stripe', short: 'St', category: 'revenue', sync: 'Payments and payouts' },
    { name: 'Shopify', short: 'Sh', category: 'revenue', sync: 'Orders and payouts' },
    { name: 'Chargebee', short: 'Cb', category: 'revenue', sync: 'Subscriptions' },
    { name: 'Salesforce', short: 'Sf', category: 'revenue', sync: 'Pipeline and bookings' },
    { name: 'Gusto', short: 'Gu', category: 'payroll', sync: 'Payroll runs' },
    { name: 'Rippling', short: 'Ri', category: 'payroll', sync: 'Payroll and headcount' },
    { name: 'Deel', short: 'De', category: 'payroll', sync: 'Global payroll' },
    { name: 'Slack', short: 'Sl', category: 'workspace', sync: 'Alerts and digests' },
    { name: 'Google Sheets', short: 'GS', category: 'workspace', sync: 'Live exports' },
    { name: 'Microsoft Excel', short: 'Ex', category: 'workspace', sync: 'Live exports' }
]

export const CATEGORY_STYLES: Record<IntegrationCategory, string> = {
    accounting: 'bg-burgundy text-gold',
    banking: 'bg-sage-dark text-cream',
    revenue: 'bg-gold text-burgundy',
    payroll: 'bg-terracotta text-cream',
    workspace: 'bg-stone-dark text-cream'
}
